module.exports = __webpack_public_path__ + "img/i-role-min3.59433d40.png";